
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class MapControlService {

    private resizeSub: Subject<any> = new Subject<any>();

    public getResizeSubject(): Observable<any> {
        return this.resizeSub.asObservable();
    }

    public resize(height: number) {
        this.resizeSub.next(height);
    }
}
